import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BACK_TO_CLAN_INFO = (
    <FormattedMessage
        id='back_to_clan_info'
        defaultMessage='К информации о клане'
    />
)



// WEBPACK FOOTER //
// ./containers/Stronghold/constants.jsx